(function () {
  const palette = [
    ['navy', '#14213d'], ['black', '#111111'], ['white', '#ffffff'],
    ['charcoal', '#3f4650'], ['grey', '#9aa1a9'], ['gray', '#9aa1a9'],
    ['royal', '#2457c5'], ['sky', '#8bc8eb'], ['blue', '#305f9e'],
    ['bottle', '#174f35'], ['moss', '#687b4b'], ['green', '#24734a'],
    ['maroon', '#6f263d'], ['burgundy', '#782f40'], ['red', '#c83432'],
    ['purple', '#6b438c'], ['orange', '#e77825'], ['yellow', '#e8c637'],
    ['pink', '#d98da2'], ['brown', '#76513b'], ['khaki', '#9a8f68'],
    ['stone', '#c7bca5'], ['natural', '#d9cfb7']
  ];

  function colourFor(name) {
    const lower = name.toLowerCase();
    for (const entry of palette) {
      if (lower.includes(entry[0])) return entry[1];
    }
    return '#dfe6ee';
  }

  function replaceUnapprovedVolumeGuide(root) {
    const guide = root.querySelector('.lmu-volume-pricing');
    if (!guide) return;
    guide.removeAttribute('data-volume-pricing');
    guide.innerHTML = '<div class="lmu-volume-pricing__heading"><h2>Website price</h2><span>Buy online at the price shown</span></div><p>The garment price shown is the website price. No quote is needed for a standard order. For larger, multi-style or complex branded orders, you can still ask us for a quote.</p>';
  }

  function init() {
    const root = document.querySelector('.lmu-pdp-v10');
    if (!root) return;

    replaceUnapprovedVolumeGuide(root);

    root.querySelectorAll('[data-colour-swatch]').forEach(function (button) {
      const circle = button.querySelector('span');
      if (!circle) return;
      const name = button.dataset.value || '';
      if (!circle.style.getPropertyValue('--swatch-colour')) {
        circle.style.setProperty('--swatch-colour', colourFor(name));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
